import { indexTopics } from '@/mocks/home';

const colorMap: Record<string, { bg: string; text: string; border: string }> = {
  primary: { bg: 'bg-primary-100/70', text: 'text-primary-700', border: 'border-primary-200/60' },
  accent: { bg: 'bg-accent-100/70', text: 'text-accent-700', border: 'border-accent-200/60' },
  secondary: {
    bg: 'bg-secondary-100/70',
    text: 'text-secondary-700',
    border: 'border-secondary-200/60',
  },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            爆料合集
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            九大内容板块，覆盖娱乐圈、网红圈、社会热点等全方位爆料资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexTopics.map((topic) => {
            const c = colorMap[topic.color] || colorMap.primary;
            return (
              <a
                key={topic.id}
                href="#cards"
                className={`group block p-5 md:p-6 rounded-xl ${c.bg} border ${c.border} hover:scale-[1.02] transition-transform cursor-pointer`}
              >
                <div className="flex items-start gap-4">
                  <div
                    className={`w-12 h-12 rounded-xl ${c.bg} border ${c.border} flex items-center justify-center flex-shrink-0`}
                  >
                    <i className={`${topic.icon} text-xl ${c.text} w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className={`font-bold text-base md:text-lg ${c.text} mb-1 font-heading`}>
                      {topic.title}
                    </h3>
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed mb-2">
                      {topic.desc}
                    </p>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-file-list-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                      {topic.count}
                    </span>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}